import * as qs from 'qs'
import graphql from './graphql'
import { getApiTokenFromSessionStorage } from './graphql'

export { graphql, getApiTokenFromSessionStorage }

const getHostName = function() {
    return window.location.origin == 'http://localhost:3000' ||
        window.location.origin == 'http://localhost:8000' ||
        window.location.origin == 'http://dev.intranet.homespotter.com:3000' ||
        window.location.origin == 'http://local.homespotter.com/'
        ? 'http://dev.intranet.homespotter.com'
        : window.location.origin
}

export const request = async (...args) => {
    const [path, opts = {}] = args
    opts.base_url = ``

    return performRequests(path, opts)
}

export const custom_ad = async (...args) => {
    const [path, opts = {}] = args
    let hostName = getHostName()

    opts.base_url = `${hostName}/custom_ad/`

    return performRequests(path, opts)
}

export const boost_dash = async (...args) => {
    const [path, opts = {}] = args
    let hostName = getHostName()

    opts.base_url = `${hostName}/boost_dash/`

    return performRequests(path, opts)
}

export const listing_search = async (...args) => {
    const [path, opts = {}] = args

    let hostName = getHostName()

    opts.base_url = `${hostName}/listing_search/`

    return performRequests(path, opts)
}

export const intranet_tools = async (...args) => {
    const [path, opts = {}] = args

    let hostName = getHostName()

    opts.base_url = `${hostName}/intranet_tools/`

    return performRequests(path, opts)
}

export const new_boost_customer = async (...args) => {
    const [path, opts = {}] = args

    let hostName = getHostName()

    opts.base_url = `${hostName}/new_boost_customer/`

    return performRequests(path, opts)
}

export const get_intranet_link = url => {
    let hostName = getHostName()
    return `${hostName}/intranet_tools/${url}`
}

const performRequests = (path, opts) => {
    switch (Array.isArray(path)) {
        case true:
            return batchRequests({ paths: path, opts })
        default:
            return makeRequest(path, opts)
    }
}

const batchRequests = request => {
    return Promise.all(
        request.paths.map(path => {
            return makeRequest(path, request.opts).catch(msg =>
                console.warn(msg)
            )
        })
    )
}

const makeRequest = (path, opts) => {
    const request = {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
    }

    let query = opts && opts.params ? `?${qs.stringify(opts.params)}` : ''

    if (opts && opts.body) {
        request.body = JSON.stringify(opts.body)
    }

    if (opts && opts.method) {
        request.method = opts.method
    }

    let append_path = (opts && opts.append_path && `/${opts.append_path}`) || ''

    return fetch(
        `${opts.base_url}${path}${append_path ? append_path : ''}${query}`,
        request
    ).then(response => response.json())
}
